import styled, { css } from 'styled-components';
import { flexColumn, flexCenterVertical } from '@stylesheets/helpers';

export const RequestContainer = styled.div`
  ${({ theme: { colors, spacing, borderRadius } }) => css`
    background: ${colors.surfaceContainer};
    border-radius: ${borderRadius.medium};
    padding: ${spacing.level3};
    margin-bottom: ${spacing.level2};

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const RequestHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level2};
  `}
`;

export const TimestampText = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodySmall.fontSize};
    line-height: ${font.bodySmall.lineHeight};
    color: ${colors.onSurface};
  `}
`;

export const HeaderLeftColumn = styled.div`
  ${flexColumn};
  min-width: 0;
  gap: 2px;
`;

export const NodeLabel = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodySmall.fontSize};
    line-height: ${font.bodySmall.lineHeight};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${colors.onSurface};
  `}
`;

export const CreditsAmount = styled.span`
  flex-shrink: 0;

  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodySmall.fontSize};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${colors.onSurface};
  `}
`;

export const MetaRow = styled.div`
  ${flexCenterVertical};
  flex-wrap: wrap;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level2};
    margin-top: ${spacing.level2};
  `}
`;

export const MetaItem = styled.span`
  ${flexCenterVertical};

  ${({ theme: { font, colors } }) => css`
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const MetaSeparator = styled.span`
  ${({ theme: { colors } }) => css`
    color: ${colors.outlineVariant};
    user-select: none;
  `}
`;

export const TokenGroup = styled.div`
  ${flexCenterVertical};

  ${({ theme: { spacing, font, colors } }) => css`
    gap: ${spacing.level1};
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const TokenValue = styled.span`
  ${({ theme: { font } }) => css`
    font-weight: ${font.labelLarge.fontWeight};
    font-variant-numeric: tabular-nums;
  `}
`;

export const TokenLabel = styled.span`
  ${({ theme: { colors } }) => css`
    color: ${colors.outline};
  `}
`;

export const DetailsRow = styled.div`
  ${({ theme: { spacing } }) => css`
    ${flexColumn};
    gap: ${spacing.level2};
    margin-top: ${spacing.level2};
  `}
`;

export const ToolList = styled.div`
  ${flexCenterVertical};
  flex-wrap: wrap;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level1};
  `}
`;

export const ToolChip = styled.span`
  display: inline-block;

  ${({ theme: { font, colors, spacing, borderRadius } }) => css`
    font-size: ${font.labelSmall.fontSize};
    font-weight: ${font.labelSmall.fontWeight};
    padding: 1px ${spacing.level2};
    border-radius: ${borderRadius.small};
    background: ${colors.primaryContainer};
    color: ${colors.onPrimaryContainer};
  `}
`;
